import { render, staticRenderFns } from "./ConfigNotifications.vue?vue&type=template&id=67942e7d"
import script from "./ConfigNotifications.vue?vue&type=script&lang=js"
export * from "./ConfigNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports